import { formatServiceTypeSingular } from '@bookpeazy/common-js';
import { AppRoutePath } from 'Pages/routes';
import Link from 'next/link';

type BrowseServiceProviderBreadcrumbsProps = {
  serviceType: string;
  serviceProviderDisplayName?: string;
  innerClass?: string;
  title?: string;
  isLocalPath?: boolean;
}

const BrowseServiceProviderBreadcrumbs: React.FC<BrowseServiceProviderBreadcrumbsProps> = ({
  serviceType,
  serviceProviderDisplayName,
  innerClass = '',
  title,
  isLocalPath = false,
}) => {
  const browseProvidersHref = isLocalPath ?
    AppRoutePath.LOCAL_PROVIDERS.replace('[city]', 'winnipeg').replace('[serviceType]', serviceType) :
    AppRoutePath.BROWSE_SERVICE_PROVIDERS.replace('[serviceType]', serviceType);

  return (
    <div className="bg-paleOrange flex justify-center py-6">
      <div className={`w-full flex flex-col gap-y-2 ${innerClass}`}>

        <div className="flex gap-x-2 flex-wrap">
          <Link href={AppRoutePath.BROWSE_SERVICE_TYPES}>
            <span
              className="text-lg font-bold text-primary uppercase"
            >
              Services
            </span>
          </Link>
          <span className="text-lg text-primary uppercase">
            /
          </span>
          <a
            href={browseProvidersHref}
            className={`text-lg text-primary uppercase ${serviceProviderDisplayName && 'font-bold'}`}
          >
            {formatServiceTypeSingular(serviceType)}
          </a>
          {serviceProviderDisplayName && (
            <>
              <span className="text-lg text-primary uppercase">
                /
              </span>
              <span className="text-lg text-primary uppercase">
                {serviceProviderDisplayName}
              </span>
            </>
          )}
        </div>

        <h1 className="text-4xl font-bold">
          {title || serviceProviderDisplayName || formatServiceTypeSingular(serviceType)}
        </h1>
      </div>
    </div>
  );
};

export default BrowseServiceProviderBreadcrumbs;
